import { PopUpContainer } from "components/PopUpContainer/PopUpContainer.component";
import { styled } from "theme/default/styled";
import { setBackgroundColor_rgba_0_0_0_50 } from "theme/setter/setBackgroundOpacityColorsValues/setBackgroundColor_rgba_0_0_0_50";

export const SInvoiceCreateFormPopUp = styled(PopUpContainer)`
  ${setBackgroundColor_rgba_0_0_0_50};
`;
